
export default class Images {
    constructor(id, cscom) {
        if (!(this instanceof Images)) {
            return new Images(id, cscom);
        }
        this.cscom = cscom;
        this.id = id;

        if (this.id) {
            this.path = `/user-site-api/user-ftp-images/${this.id}`;
        } else {
            this.path = `/user-site-api/user-ftp-images`;
        }
    }

    get(data) {
        return this.cscom.req.get(this.path, null, data);
    }
    
    list(data) {
        return this.cscom.req.get(this.path, data);
    }

    search(data) {
        return this.cscom.req.get(this.path, data);
    }
 
}
